module.exports = __webpack_public_path__ + "img/intro_mock.66f6575f.png";